<template>
    <div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" :title="dataEvent.title" :hide-footer="true" v-model="dataShow">
            <b-row>
                <b-col>
                    <table class="table table-no-border">
                        <tbody>
                        <tr>
                            <td colspan="2">
                                <small v-html="Mantle.EventDate.getStatusLabelWithIcon(dataEvent.status)"></small>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Début')}}:</strong> {{Core.Date.readableDate(dataEvent.start, 'DD MMM Y - HH:mm')}}
                            </td>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Fin')}}:</strong> {{Core.Date.readableDate(dataEvent.end, 'DD MMM Y - HH:mm')}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Responsable')}}:</strong> {{Mantle.Event.readableResponsables(dataEvent.eventDateUsers)}}
                            </td>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Réservations')}}:</strong> {{Mantle.Event.readableBookingCount(dataEvent.eventDateBookingCount, dataEvent.max)}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Liste d\'attente')}}:</strong> {{dataEvent.eventDateWaitingCount}}
                            </td>
                            <td>
                                <strong>{{Core.Definition.getDefinition('Annulation')}}:</strong> {{dataEvent.eventDateCancelCount}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button-group>
                        <b-button v-if="Core.Session.AuthUser.can('event_calendar_management_put')" @click="onEditClick" class="btn btn-light">{{Core.Definition.getDefinition('Modififier l\'événement')}}</b-button><br/>
                        <b-button v-if="Core.Session.AuthUser.can('event_booking_management_post_book')" @click="onAddBookingClick" class="btn btn-light">{{Core.Definition.getDefinition('Ajouter des réservations')}}</b-button>
                        <b-button v-if="Core.Session.AuthUser.can('event_booking_management_get')" @click="onBookingsClick" class="btn btn-light">{{Core.Definition.getDefinition('Voir les réservations')}}</b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-modal>
    </div>

</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import MultipleUserBooking from './MultipleUserBooking'
    import DynamicForm from './DynamicForm'
    import ModalInstanceSelector from './ModalInstanceSelector'
    import Alert from './Alert'
    export default {
        name: 'ModalEventDate',
        components: {
            DynamicForm,
            ModalInstanceSelector,
            MultipleUserBooking
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            event: {
                set(event) {
                    this.dataEvent = event
                },
                get() {
                    return this.dataEvent
                }
            },
            date: {
                set(date) {
                    this.dataDate = date
                },
                get() {
                    return this.dataDate
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataEvent: {},
                dataDate: '',
                dataShow: false,
            }
        },
        methods: {
            onEditClick() {
                this.$emit('onEditClick', this.dataEvent, this.dataDate)
            },
            onAddBookingClick() {
                this.$emit('onAddBookingClick', this.dataEvent, this.dataDate)
            },
            onBookingsClick() {
                this.$emit('onBookingsClick', this.dataEvent, this.dataDate)
            }
        }
    }
</script>
